<script>
  import { Pie } from 'vue-chartjs'
import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels';

export default {
    components: {
    ChartJsPluginDataLabels,
  },
    extends: Pie,
    props: {
      chartData: {
        type: Object,
        default: null,
        required: true
      },
       options: {
      type: Object,
      default: null
    }
    },
    
    mounted () {
         this.renderChart(this.chartData, this.options)
    },
   
  }
</script>
